import { MAIN_API_URL } from "./auth";

export async function fetchMe() {
  const access = localStorage.getItem("access");
  const user_id = localStorage.getItem('user_id')

  const res = await fetch(`${MAIN_API_URL}/me/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });

  const data = await res.json();

  if (!res.ok) {
    const err = new Error(data?.detail || "Failed to fetch user info");
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}
